import {GET_SHOPPING_LIST_DETAILS } from './types';


export const getShoppingListDetails = (listDetails) => dispatch => {
    dispatch({
        type: GET_SHOPPING_LIST_DETAILS,
        listDetails: listDetails,
    })

}
